import Button from '../../components/button/button'
import { getText } from '../../utils/dictionary'
import Landing from './landing'

export default class FirstLanding extends Landing {
  static _template() {
    return {
      ...super._template(),
      SkipButton: {
        y: 860,
        x: 1520,
        type: Button,
        label: getText('landingSkipButton'),
        isTransparent: true,
      },
    }
  }

  get skipButton() {
    return this.tag('SkipButton')
  }

  _handleRight() {
    if (this._currentButton === this.loginButton) {
      this._currentButton = this.signUpButton
    } else if (this._currentButton === this.signUpButton) {
      this._currentButton = this.skipButton
    }
  }

  _handleLeft() {
    if (this._currentButton === this.skipButton) {
      this._currentButton = this.signUpButton
    } else if (this._currentButton === this.signUpButton) {
      this._currentButton = this.loginButton
    }
  }
}
